import { isSubscriptionPaymentRequired } from "~/utils/subscriptionAccess";

export default defineNuxtPlugin(() => {
	const originalFetch = globalThis.fetch.bind(globalThis);
	globalThis.fetch = async (...args: Parameters<typeof fetch>) => {
		const response = await originalFetch(...args);
		if (response.status === 402 && window.location.pathname !== "/payment-required") {
			try {
				if (isSubscriptionPaymentRequired(await response.clone().json())) {
					window.location.assign("/payment-required");
				}
			} catch {
				// Preserve ordinary fetch behavior for non-JSON errors.
			}
		}
		return response;
	};
});
